export const dptos = [
  {
    dpto: "A",
    nombre: "ASUNCION",
  },
  {
    dpto: "B",
    nombre: "CONCEPCION",
  },
  {
    dpto: "C",
    nombre: "SAN PEDRO",
  },
  {
    dpto: "D",
    nombre: "CORDILLERA",
  },
  {
    dpto: "E",
    nombre: "GUAIRA",
  },
  {
    dpto: "F",
    nombre: "CAAGUAZU",
  },
  {
    dpto: "G",
    nombre: "CAAZAPA",
  },
  {
    dpto: "H",
    nombre: "ITAPUA",
  },
  {
    dpto: "I",
    nombre: "MISIONES",
  },
  {
    dpto: "J",
    nombre: "PARAGUARI",
  },
  {
    dpto: "K",
    nombre: "ALTO PARANA",
  },
  {
    dpto: "L",
    nombre: "CENTRAL",
  },
  {
    dpto: "M",
    nombre: "ÑEEMBUCU",
  },
  {
    dpto: "N",
    nombre: "AMAMBAY",
  },
  {
    dpto: "P",
    nombre: "PDTE. HAYES",
  },
  {
    dpto: "Q",
    nombre: "BOQUERON",
  },
  {
    dpto: "R",
    nombre: "ALTO PARAGUAY",
  },
  {
    dpto: "S",
    nombre: "CANINDEYU",
  },
];

export const dists = [
  {
    cod_dpto: "A",
    cod_dist: "A02",
    nom_dist: "LA CATEDRAL",
  },
  {
    cod_dpto: "A",
    cod_dist: "A03",
    nom_dist: "SAN ROQUE",
  },
  {
    cod_dpto: "A",
    cod_dist: "A04",
    nom_dist: "STA. MARIA DE LA ASUNCION",
  },
  {
    cod_dpto: "A",
    cod_dist: "A05",
    nom_dist: "LA RECOLETA",
  },
  {
    cod_dpto: "B",
    cod_dist: "B07",
    nom_dist: "SAN SALVADOR",
  },
  {
    cod_dpto: "K",
    cod_dist: "K04",
    nom_dist: "CIUDAD DEL ESTE",
  },
  {
    cod_dpto: "H",
    cod_dist: "H29",
    nom_dist: "ALTO VERA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D12",
    nom_dist: "PIRIBEBUY",
  },
  {
    cod_dpto: "I",
    cod_dist: "I09",
    nom_dist: "VILLA FLORIDA",
  },
  {
    cod_dpto: "M",
    cod_dist: "M14",
    nom_dist: "VILLA OLIVA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L03",
    nom_dist: "FDO. DE LA MORA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L12",
    nom_dist: "SAN ANTONIO",
  },
  {
    cod_dpto: "S",
    cod_dist: "S06",
    nom_dist: "ITANARA",
  },
  {
    cod_dpto: "C",
    cod_dist: "C22",
    nom_dist: "SAN VICENTE PANCHOLO",
  },
  {
    cod_dpto: "Q",
    cod_dist: "Q02",
    nom_dist: "BOQUERON - N.E. (ANTECEDENTES)",
  },
  {
    cod_dpto: "Q",
    cod_dist: "Q04",
    nom_dist: "PEDRO P. PEÑA",
  },
  {
    cod_dpto: "Q",
    cod_dist: "Q06",
    nom_dist: "GRAL.E.A.GARAY",
  },
  {
    cod_dpto: "R",
    cod_dist: "R04",
    nom_dist: "MAYOR PABLO LAGERENZA",
  },
  {
    cod_dpto: "A",
    cod_dist: "A01",
    nom_dist: "LA ENCARNACION",
  },
  {
    cod_dpto: "A",
    cod_dist: "A06",
    nom_dist: "STMA. TRINIDAD",
  },
  {
    cod_dpto: "H",
    cod_dist: "H05",
    nom_dist: "FEDERICO CHAVEZ (ANTECEDENTES)",
  },
  {
    cod_dpto: "P",
    cod_dist: "P03",
    nom_dist: "POZO COLORADO",
  },
  {
    cod_dpto: "D",
    cod_dist: "D10",
    nom_dist: "JUAN DE MENA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L19",
    nom_dist: "LAMBARE",
  },
  {
    cod_dpto: "N",
    cod_dist: "N05",
    nom_dist: "KARAPAI",
  },
  {
    cod_dpto: "P",
    cod_dist: "P06",
    nom_dist: "JOSE FALCON",
  },
  {
    cod_dpto: "F",
    cod_dist: "F21",
    nom_dist: "3 DE FEBRERO",
  },
  {
    cod_dpto: "K",
    cod_dist: "K16",
    nom_dist: "MINGA PORA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L14",
    nom_dist: "VILLA ELISA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L13",
    nom_dist: "SAN LORENZO",
  },
  {
    cod_dpto: "M",
    cod_dist: "M10",
    nom_dist: "PASO DE PATRIA",
  },
  {
    cod_dpto: "N",
    cod_dist: "N02",
    nom_dist: "BELLA VISTA (NORTE)",
  },
  {
    cod_dpto: "B",
    cod_dist: "B14",
    nom_dist: "PASO HORQUETA",
  },
  {
    cod_dpto: "N",
    cod_dist: "N06",
    nom_dist: "CERRO CORA",
  },
  {
    cod_dpto: "P",
    cod_dist: "P07",
    nom_dist: "TTE.1° MANUEL IRALA FERNANDEZ",
  },
  {
    cod_dpto: "K",
    cod_dist: "K15",
    nom_dist: "SAN ALBERTO",
  },
  {
    cod_dpto: "M",
    cod_dist: "M02",
    nom_dist: "ALBERDI",
  },
  {
    cod_dpto: "K",
    cod_dist: "K02",
    nom_dist: "DOMINGO M.DE IRALA",
  },
  {
    cod_dpto: "B",
    cod_dist: "B03",
    nom_dist: "SAN CARLOS",
  },
  {
    cod_dpto: "G",
    cod_dist: "G02",
    nom_dist: "BUENA VISTA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L10",
    nom_dist: "ÑEMBY",
  },
  {
    cod_dpto: "S",
    cod_dist: "S04",
    nom_dist: "YPEJHU",
  },
  {
    cod_dpto: "P",
    cod_dist: "P10",
    nom_dist: "CAMPO ACEVAL",
  },
  {
    cod_dpto: "F",
    cod_dist: "F18",
    nom_dist: "R.I.3 CORRALES",
  },
  {
    cod_dpto: "M",
    cod_dist: "M08",
    nom_dist: "ISLA UMBU",
  },
  {
    cod_dpto: "P",
    cod_dist: "P11",
    nom_dist: "NUEVA ASUNCION",
  },
  {
    cod_dpto: "L",
    cod_dist: "L05",
    nom_dist: "ITA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H02",
    nom_dist: "BELLA VISTA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D19",
    nom_dist: "MBOCAYATY DEL YHAGUY",
  },
  {
    cod_dpto: "E",
    cod_dist: "E11",
    nom_dist: "ITURBE",
  },
  {
    cod_dpto: "M",
    cod_dist: "M01",
    nom_dist: "PILAR",
  },
  {
    cod_dpto: "H",
    cod_dist: "H12",
    nom_dist: "HOHENAU",
  },
  {
    cod_dpto: "H",
    cod_dist: "H09",
    nom_dist: "FRAM",
  },
  {
    cod_dpto: "H",
    cod_dist: "H13",
    nom_dist: "JESUS",
  },
  {
    cod_dpto: "K",
    cod_dist: "K03",
    nom_dist: "ÑACUNDAY",
  },
  {
    cod_dpto: "I",
    cod_dist: "I07",
    nom_dist: "SANTA MARIA",
  },
  {
    cod_dpto: "M",
    cod_dist: "M07",
    nom_dist: "HUMAITA",
  },
  {
    cod_dpto: "P",
    cod_dist: "P05",
    nom_dist: "NANAWA",
  },
  {
    cod_dpto: "E",
    cod_dist: "E05",
    nom_dist: "GRAL.E.A.GARAY",
  },
  {
    cod_dpto: "I",
    cod_dist: "I10",
    nom_dist: "YABEBYRY",
  },
  {
    cod_dpto: "S",
    cod_dist: "S16",
    nom_dist: "LAUREL",
  },
  {
    cod_dpto: "K",
    cod_dist: "K07",
    nom_dist: "JUAN E.O'LEARY",
  },
  {
    cod_dpto: "J",
    cod_dist: "J16",
    nom_dist: "TEBICUARY MI",
  },
  {
    cod_dpto: "E",
    cod_dist: "E17",
    nom_dist: "DR. BOTRELL",
  },
  {
    cod_dpto: "L",
    cod_dist: "L09",
    nom_dist: "MARIANO R.ALONSO",
  },
  {
    cod_dpto: "Q",
    cod_dist: "Q03",
    nom_dist: "LOMA PLATA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H26",
    nom_dist: "LA PAZ",
  },
  {
    cod_dpto: "C",
    cod_dist: "C04",
    nom_dist: "ITAC. DEL ROSARIO",
  },
  {
    cod_dpto: "H",
    cod_dist: "H10",
    nom_dist: "GENERAL ARTIGAS",
  },
  {
    cod_dpto: "G",
    cod_dist: "G05",
    nom_dist: "MOISES BERTONI",
  },
  {
    cod_dpto: "I",
    cod_dist: "I06",
    nom_dist: "SANTIAGO",
  },
  {
    cod_dpto: "F",
    cod_dist: "F07",
    nom_dist: "NUEVA LONDRES",
  },
  {
    cod_dpto: "J",
    cod_dist: "J02",
    nom_dist: "ACAHAY",
  },
  {
    cod_dpto: "H",
    cod_dist: "H30",
    nom_dist: "PIRAPO",
  },
  {
    cod_dpto: "K",
    cod_dist: "K06",
    nom_dist: "ITAKYRY",
  },
  {
    cod_dpto: "R",
    cod_dist: "R03",
    nom_dist: "PUERTO CASADO",
  },
  {
    cod_dpto: "B",
    cod_dist: "B12",
    nom_dist: "PASO BARRETO",
  },
  {
    cod_dpto: "F",
    cod_dist: "F17",
    nom_dist: "JOSE D. OCAMPOS",
  },
  {
    cod_dpto: "G",
    cod_dist: "G06",
    nom_dist: "SAN J.NEPOMUCENO",
  },
  {
    cod_dpto: "S",
    cod_dist: "S08",
    nom_dist: "KATUETE",
  },
  {
    cod_dpto: "B",
    cod_dist: "B05",
    nom_dist: "LORETO",
  },
  {
    cod_dpto: "M",
    cod_dist: "M06",
    nom_dist: "GUAZU CUA",
  },
  {
    cod_dpto: "G",
    cod_dist: "G01",
    nom_dist: "CAAZAPA",
  },
  {
    cod_dpto: "J",
    cod_dist: "J04",
    nom_dist: "CABALLERO",
  },
  {
    cod_dpto: "E",
    cod_dist: "E10",
    nom_dist: "ITAPE",
  },
  {
    cod_dpto: "B",
    cod_dist: "B10",
    nom_dist: "SARGENTO JOSE FELIX LOPEZ",
  },
  {
    cod_dpto: "E",
    cod_dist: "E09",
    nom_dist: "MAURICIO J.TROCHE",
  },
  {
    cod_dpto: "J",
    cod_dist: "J03",
    nom_dist: "CAAPUCU",
  },
  {
    cod_dpto: "D",
    cod_dist: "D13",
    nom_dist: "PRIMERO DE MARZO",
  },
  {
    cod_dpto: "I",
    cod_dist: "I05",
    nom_dist: "SAN PATRICIO",
  },
  {
    cod_dpto: "E",
    cod_dist: "E03",
    nom_dist: "BORJA",
  },
  {
    cod_dpto: "F",
    cod_dist: "F22",
    nom_dist: "SIMON BOLIVAR",
  },
  {
    cod_dpto: "H",
    cod_dist: "H11",
    nom_dist: "GENERAL DELGADO",
  },
  {
    cod_dpto: "R",
    cod_dist: "R01",
    nom_dist: "FUERTE OLIMPO",
  },
  {
    cod_dpto: "C",
    cod_dist: "C02",
    nom_dist: "ANTEQUERA",
  },
  {
    cod_dpto: "J",
    cod_dist: "J06",
    nom_dist: "LA COLMENA",
  },
  {
    cod_dpto: "E",
    cod_dist: "E15",
    nom_dist: "ÑUMI",
  },
  {
    cod_dpto: "D",
    cod_dist: "D08",
    nom_dist: "ISLA PUCU",
  },
  {
    cod_dpto: "F",
    cod_dist: "F10",
    nom_dist: "YHU",
  },
  {
    cod_dpto: "E",
    cod_dist: "E06",
    nom_dist: "CORONEL MARTINEZ",
  },
  {
    cod_dpto: "J",
    cod_dist: "J15",
    nom_dist: "YBYTIMI",
  },
  {
    cod_dpto: "S",
    cod_dist: "S03",
    nom_dist: "VILLA YGATYMI",
  },
  {
    cod_dpto: "K",
    cod_dist: "K20",
    nom_dist: "SANTA FE DEL PARANA",
  },
  {
    cod_dpto: "M",
    cod_dist: "M12",
    nom_dist: "SAN JUAN DE ÑEEMBUCU",
  },
  {
    cod_dpto: "E",
    cod_dist: "E14",
    nom_dist: "TEBICUARY",
  },
  {
    cod_dpto: "M",
    cod_dist: "M13",
    nom_dist: "TACUARAS",
  },
  {
    cod_dpto: "D",
    cod_dist: "D17",
    nom_dist: "VALENZUELA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D02",
    nom_dist: "ALTOS",
  },
  {
    cod_dpto: "C",
    cod_dist: "C12",
    nom_dist: "YATAITY DEL NORTE",
  },
  {
    cod_dpto: "J",
    cod_dist: "J17",
    nom_dist: "YAGUARON",
  },
  {
    cod_dpto: "M",
    cod_dist: "M05",
    nom_dist: "GRAL.J.E.DIAZ",
  },
  {
    cod_dpto: "C",
    cod_dist: "C06",
    nom_dist: "LIMA",
  },
  {
    cod_dpto: "E",
    cod_dist: "E07",
    nom_dist: "JOSE FASSARDI",
  },
  {
    cod_dpto: "K",
    cod_dist: "K09",
    nom_dist: "YGUAZU",
  },
  {
    cod_dpto: "I",
    cod_dist: "I02",
    nom_dist: "AYOLAS",
  },
  {
    cod_dpto: "G",
    cod_dist: "G11",
    nom_dist: "3 DE MAYO",
  },
  {
    cod_dpto: "J",
    cod_dist: "J01",
    nom_dist: "PARAGUARI",
  },
  {
    cod_dpto: "E",
    cod_dist: "E08",
    nom_dist: "FELIX P. CARDOZO",
  },
  {
    cod_dpto: "G",
    cod_dist: "G10",
    nom_dist: "YUTY",
  },
  {
    cod_dpto: "R",
    cod_dist: "R05",
    nom_dist: "CARMELO PERALTA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D09",
    nom_dist: "ITAC. DE LA CORDILLERA",
  },
  {
    cod_dpto: "F",
    cod_dist: "F03",
    nom_dist: "CARAYAO",
  },
  {
    cod_dpto: "R",
    cod_dist: "R02",
    nom_dist: "BAHIA NEGRA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H17",
    nom_dist: "NUEVA ALBORADA",
  },
  {
    cod_dpto: "B",
    cod_dist: "B04",
    nom_dist: "BELEN",
  },
  {
    cod_dpto: "C",
    cod_dist: "C13",
    nom_dist: "GRAL. ISIDORO RESQUIN",
  },
  {
    cod_dpto: "C",
    cod_dist: "C15",
    nom_dist: "SAN PABLO",
  },
  {
    cod_dpto: "F",
    cod_dist: "F24",
    nom_dist: "VAQUERIA",
  },
  {
    cod_dpto: "S",
    cod_dist: "S07",
    nom_dist: "F.CABALLERO ALVAREZ",
  },
  {
    cod_dpto: "C",
    cod_dist: "C19",
    nom_dist: "SANTA ROSA DEL AGUARAY",
  },
  {
    cod_dpto: "I",
    cod_dist: "I01",
    nom_dist: "SAN JUAN BAUTISTA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D05",
    nom_dist: "CARAGUATAY",
  },
  {
    cod_dpto: "D",
    cod_dist: "D06",
    nom_dist: "EMBOSCADA",
  },
  {
    cod_dpto: "Q",
    cod_dist: "Q05",
    nom_dist: "FILADELFIA",
  },
  {
    cod_dpto: "F",
    cod_dist: "F09",
    nom_dist: "SAN JOSE DE LOS ARROYOS",
  },
  {
    cod_dpto: "H",
    cod_dist: "H22",
    nom_dist: "CARLOS A. LOPEZ",
  },
  {
    cod_dpto: "C",
    cod_dist: "C09",
    nom_dist: "UNION",
  },
  {
    cod_dpto: "K",
    cod_dist: "K13",
    nom_dist: "MINGA GUAZU",
  },
  {
    cod_dpto: "K",
    cod_dist: "K18",
    nom_dist: "IRUÑA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H14",
    nom_dist: "OBLIGADO",
  },
  {
    cod_dpto: "J",
    cod_dist: "J12",
    nom_dist: "SAPUCAI",
  },
  {
    cod_dpto: "F",
    cod_dist: "F14",
    nom_dist: "REPATRIACION",
  },
  {
    cod_dpto: "H",
    cod_dist: "H18",
    nom_dist: "TRINIDAD",
  },
  {
    cod_dpto: "C",
    cod_dist: "C01",
    nom_dist: "SAN PEDRO",
  },
  {
    cod_dpto: "F",
    cod_dist: "F04",
    nom_dist: "DR. CECILIO BAEZ",
  },
  {
    cod_dpto: "C",
    cod_dist: "C08",
    nom_dist: "TACUATI",
  },
  {
    cod_dpto: "D",
    cod_dist: "D15",
    nom_dist: "SANTA ELENA",
  },
  {
    cod_dpto: "M",
    cod_dist: "M03",
    nom_dist: "CERRITO",
  },
  {
    cod_dpto: "E",
    cod_dist: "E02",
    nom_dist: "SAN SALVADOR",
  },
  {
    cod_dpto: "F",
    cod_dist: "F13",
    nom_dist: "JUAN M. FRUTOS",
  },
  {
    cod_dpto: "S",
    cod_dist: "S14",
    nom_dist: "MARACANA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L04",
    nom_dist: "GUARAMBARE",
  },
  {
    cod_dpto: "M",
    cod_dist: "M04",
    nom_dist: "DESMOCHADOS",
  },
  {
    cod_dpto: "C",
    cod_dist: "C18",
    nom_dist: "CAPIIBARY",
  },
  {
    cod_dpto: "K",
    cod_dist: "K21",
    nom_dist: "TAVAPY",
  },
  {
    cod_dpto: "H",
    cod_dist: "H06",
    nom_dist: "CARMEN DEL PARANA",
  },
  {
    cod_dpto: "E",
    cod_dist: "E16",
    nom_dist: "YATAITY",
  },
  {
    cod_dpto: "C",
    cod_dist: "C11",
    nom_dist: "VILLA DEL ROSARIO",
  },
  {
    cod_dpto: "F",
    cod_dist: "F23",
    nom_dist: "LA PASTORA",
  },
  {
    cod_dpto: "Q",
    cod_dist: "Q07",
    nom_dist: "BOQUERON",
  },
  {
    cod_dpto: "N",
    cod_dist: "N04",
    nom_dist: "ZANJA PYTA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L06",
    nom_dist: "ITAUGUA",
  },
  {
    cod_dpto: "J",
    cod_dist: "J05",
    nom_dist: "CARAPEGUA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H23",
    nom_dist: "MAYOR J.D. OTAÑO",
  },
  {
    cod_dpto: "S",
    cod_dist: "S01",
    nom_dist: "SALTO DEL GUAIRA",
  },
  {
    cod_dpto: "M",
    cod_dist: "M17",
    nom_dist: "VILLALBIN",
  },
  {
    cod_dpto: "J",
    cod_dist: "J08",
    nom_dist: "MBUYAPEY",
  },
  {
    cod_dpto: "G",
    cod_dist: "G03",
    nom_dist: "GRAL. H.MORINIGO",
  },
  {
    cod_dpto: "J",
    cod_dist: "J10",
    nom_dist: "QUIINDY",
  },
  {
    cod_dpto: "Q",
    cod_dist: "Q01",
    nom_dist: "MCAL.ESTIGARRIBIA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H03",
    nom_dist: "CAMBYRETA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H25",
    nom_dist: "SAN JUAN DEL PARANA",
  },
  {
    cod_dpto: "J",
    cod_dist: "J11",
    nom_dist: "SAN ROQUE GONZALEZ",
  },
  {
    cod_dpto: "K",
    cod_dist: "K11",
    nom_dist: "SANTA RITA",
  },
  {
    cod_dpto: "P",
    cod_dist: "P08",
    nom_dist: "TTE. ESTEBAN MARTINEZ",
  },
  {
    cod_dpto: "L",
    cod_dist: "L08",
    nom_dist: "LUQUE",
  },
  {
    cod_dpto: "I",
    cod_dist: "I03",
    nom_dist: "SAN IGNACIO",
  },
  {
    cod_dpto: "F",
    cod_dist: "F02",
    nom_dist: "CAAGUAZU",
  },
  {
    cod_dpto: "M",
    cod_dist: "M11",
    nom_dist: "MAYOR J.MARTINEZ",
  },
  {
    cod_dpto: "E",
    cod_dist: "E13",
    nom_dist: "NATALICIO TALAVERA",
  },
  {
    cod_dpto: "N",
    cod_dist: "N01",
    nom_dist: "PEDRO J.CABALLERO",
  },
  {
    cod_dpto: "F",
    cod_dist: "F08",
    nom_dist: "SAN JOAQUIN",
  },
  {
    cod_dpto: "J",
    cod_dist: "J18",
    nom_dist: "MARIA ANTONIA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L07",
    nom_dist: "LIMPIO",
  },
  {
    cod_dpto: "G",
    cod_dist: "G08",
    nom_dist: "TAVAI",
  },
  {
    cod_dpto: "F",
    cod_dist: "F19",
    nom_dist: "RAUL A. OVIEDO",
  },
  {
    cod_dpto: "K",
    cod_dist: "K22",
    nom_dist: "DR. RAUL PEÑA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D14",
    nom_dist: "SAN BERNARDINO",
  },
  {
    cod_dpto: "H",
    cod_dist: "H07",
    nom_dist: "CAPITAN MIRANDA",
  },
  {
    cod_dpto: "K",
    cod_dist: "K01",
    nom_dist: "HERNANDARIAS",
  },
  {
    cod_dpto: "B",
    cod_dist: "B11",
    nom_dist: "SAN ALFREDO",
  },
  {
    cod_dpto: "H",
    cod_dist: "H20",
    nom_dist: "JOSE L. OVIEDO",
  },
  {
    cod_dpto: "J",
    cod_dist: "J14",
    nom_dist: "QUYQUYHO",
  },
  {
    cod_dpto: "H",
    cod_dist: "H15",
    nom_dist: "SAN COSME Y DAMIAN",
  },
  {
    cod_dpto: "F",
    cod_dist: "F15",
    nom_dist: "SANTA ROSA DEL MBUTUY",
  },
  {
    cod_dpto: "B",
    cod_dist: "B08",
    nom_dist: "YBY YAU",
  },
  {
    cod_dpto: "N",
    cod_dist: "N03",
    nom_dist: "CAPITAN BADO",
  },
  {
    cod_dpto: "L",
    cod_dist: "L15",
    nom_dist: "VILLETA",
  },
  {
    cod_dpto: "C",
    cod_dist: "C21",
    nom_dist: "LIBERACION",
  },
  {
    cod_dpto: "D",
    cod_dist: "D04",
    nom_dist: "ATYRA",
  },
  {
    cod_dpto: "M",
    cod_dist: "M15",
    nom_dist: "VILLA FRANCA",
  },
  {
    cod_dpto: "S",
    cod_dist: "S05",
    nom_dist: "CORPUS CHRISTI",
  },
  {
    cod_dpto: "F",
    cod_dist: "F01",
    nom_dist: "CORONEL OVIEDO",
  },
  {
    cod_dpto: "H",
    cod_dist: "H31",
    nom_dist: "ITAPUA POTY",
  },
  {
    cod_dpto: "F",
    cod_dist: "F05",
    nom_dist: "NUEVA TOLEDO",
  },
  {
    cod_dpto: "E",
    cod_dist: "E12",
    nom_dist: "MBOCAYATY DEL GUAIRA",
  },
  {
    cod_dpto: "F",
    cod_dist: "F16",
    nom_dist: "DR.J.E.ESTIGARRIBIA",
  },
  {
    cod_dpto: "C",
    cod_dist: "C17",
    nom_dist: "GUAJAYVI",
  },
  {
    cod_dpto: "S",
    cod_dist: "S13",
    nom_dist: "YBY PYTÁ",
  },
  {
    cod_dpto: "M",
    cod_dist: "M09",
    nom_dist: "LAURELES",
  },
  {
    cod_dpto: "I",
    cod_dist: "I04",
    nom_dist: "SAN MIGUEL",
  },
  {
    cod_dpto: "C",
    cod_dist: "C20",
    nom_dist: "YRYBUCUA",
  },
  {
    cod_dpto: "P",
    cod_dist: "P09",
    nom_dist: "GRAL.JOSE MARIA BRUGUEZ",
  },
  {
    cod_dpto: "K",
    cod_dist: "K19",
    nom_dist: "MBARACAYU",
  },
  {
    cod_dpto: "S",
    cod_dist: "S11",
    nom_dist: "YASY CAÑY",
  },
  {
    cod_dpto: "F",
    cod_dist: "F20",
    nom_dist: "MCAL. F.S.LOPEZ",
  },
  {
    cod_dpto: "C",
    cod_dist: "C16",
    nom_dist: "SAN JOSE DEL ROSARIO(ANTECEDENTES)",
  },
  {
    cod_dpto: "S",
    cod_dist: "S15",
    nom_dist: "PUERTO ADELA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D03",
    nom_dist: "ARROYOS Y ESTEROS",
  },
  {
    cod_dpto: "B",
    cod_dist: "B09",
    nom_dist: "AZOTE'Y",
  },
  {
    cod_dpto: "C",
    cod_dist: "C23",
    nom_dist: "SAN JOSÉ DEL ROSARIO",
  },
  {
    cod_dpto: "B",
    cod_dist: "B02",
    nom_dist: "SAN LAZARO",
  },
  {
    cod_dpto: "I",
    cod_dist: "I08",
    nom_dist: "SANTA ROSA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H28",
    nom_dist: "YATYTAY",
  },
  {
    cod_dpto: "S",
    cod_dist: "S10",
    nom_dist: "NUEVA ESPERANZA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L18",
    nom_dist: "YPANE",
  },
  {
    cod_dpto: "K",
    cod_dist: "K12",
    nom_dist: "LOS CEDRALES",
  },
  {
    cod_dpto: "K",
    cod_dist: "K08",
    nom_dist: "PTE. FRANCO",
  },
  {
    cod_dpto: "P",
    cod_dist: "P04",
    nom_dist: "PUERTO PINASCO",
  },
  {
    cod_dpto: "C",
    cod_dist: "C10",
    nom_dist: "25 DE DICIEMBRE",
  },
  {
    cod_dpto: "C",
    cod_dist: "C03",
    nom_dist: "GRAL. E. AQUINO",
  },
  {
    cod_dpto: "S",
    cod_dist: "S09",
    nom_dist: "LA PALOMA",
  },
  {
    cod_dpto: "P",
    cod_dist: "P01",
    nom_dist: "VILLA HAYES",
  },
  {
    cod_dpto: "D",
    cod_dist: "D07",
    nom_dist: "EUSEBIO AYALA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H19",
    nom_dist: "NATALIO",
  },
  {
    cod_dpto: "J",
    cod_dist: "J09",
    nom_dist: "PIRAYU",
  },
  {
    cod_dpto: "S",
    cod_dist: "S02",
    nom_dist: "CURUGUATY",
  },
  {
    cod_dpto: "E",
    cod_dist: "E18",
    nom_dist: "PASO YOBAI",
  },
  {
    cod_dpto: "P",
    cod_dist: "P02",
    nom_dist: "BENJAMIN ACEVAL",
  },
  {
    cod_dpto: "H",
    cod_dist: "H08",
    nom_dist: "CORONEL BOGADO",
  },
  {
    cod_dpto: "D",
    cod_dist: "D11",
    nom_dist: "NUEVA COLOMBIA",
  },
  {
    cod_dpto: "F",
    cod_dist: "F25",
    nom_dist: "TEMBIAPORA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H27",
    nom_dist: "TOMAS R. PEREIRA",
  },
  {
    cod_dpto: "D",
    cod_dist: "D16",
    nom_dist: "TOBATI",
  },
  {
    cod_dpto: "D",
    cod_dist: "D18",
    nom_dist: "LOMA GRANDE",
  },
  {
    cod_dpto: "J",
    cod_dist: "J13",
    nom_dist: "YBYCUI",
  },
  {
    cod_dpto: "G",
    cod_dist: "G07",
    nom_dist: "ABAI",
  },
  {
    cod_dpto: "E",
    cod_dist: "E04",
    nom_dist: "INDEPENDENCIA",
  },
  {
    cod_dpto: "S",
    cod_dist: "S12",
    nom_dist: "YBYRAROBANÁ",
  },
  {
    cod_dpto: "L",
    cod_dist: "L17",
    nom_dist: "YPACARAI",
  },
  {
    cod_dpto: "H",
    cod_dist: "H01",
    nom_dist: "ENCARNACION",
  },
  {
    cod_dpto: "B",
    cod_dist: "B06",
    nom_dist: "HORQUETA",
  },
  {
    cod_dpto: "B",
    cod_dist: "B13",
    nom_dist: "ARROYITO",
  },
  {
    cod_dpto: "C",
    cod_dist: "C14",
    nom_dist: "CHORE",
  },
  {
    cod_dpto: "D",
    cod_dist: "D01",
    nom_dist: "CAACUPE",
  },
  {
    cod_dpto: "D",
    cod_dist: "D20",
    nom_dist: "SAN JOSE OBRERO",
  },
  {
    cod_dpto: "G",
    cod_dist: "G09",
    nom_dist: "YEGROS",
  },
  {
    cod_dpto: "H",
    cod_dist: "H16",
    nom_dist: "SAN PEDRO DEL PARANA",
  },
  {
    cod_dpto: "H",
    cod_dist: "H24",
    nom_dist: "EDELIRA",
  },
  {
    cod_dpto: "K",
    cod_dist: "K14",
    nom_dist: "NARANJAL",
  },
  {
    cod_dpto: "H",
    cod_dist: "H04",
    nom_dist: "CAPITAN MEZA",
  },
  {
    cod_dpto: "J",
    cod_dist: "J07",
    nom_dist: "ESCOBAR",
  },
  {
    cod_dpto: "L",
    cod_dist: "L02",
    nom_dist: "CAPIATA",
  },
  {
    cod_dpto: "C",
    cod_dist: "C07",
    nom_dist: "NUEVA GERMANIA",
  },
  {
    cod_dpto: "L",
    cod_dist: "L20",
    nom_dist: "J. AUGUSTO SALDIVAR",
  },
  {
    cod_dpto: "L",
    cod_dist: "L01",
    nom_dist: "AREGUA",
  },
  {
    cod_dpto: "K",
    cod_dist: "K05",
    nom_dist: "J.L.MALLORQUIN",
  },
  {
    cod_dpto: "L",
    cod_dist: "L11",
    nom_dist: "NUEVA ITALIA",
  },
  {
    cod_dpto: "G",
    cod_dist: "G04",
    nom_dist: "MACIEL",
  },
  {
    cod_dpto: "C",
    cod_dist: "C05",
    nom_dist: "SAN ESTANISLAO",
  },
  {
    cod_dpto: "H",
    cod_dist: "H21",
    nom_dist: "SAN RAFAEL DEL PARANA",
  },
  {
    cod_dpto: "E",
    cod_dist: "E01",
    nom_dist: "VILLARRICA",
  },
  {
    cod_dpto: "K",
    cod_dist: "K17",
    nom_dist: "SANTA ROSA DEL MONDAY",
  },
  {
    cod_dpto: "B",
    cod_dist: "B01",
    nom_dist: "CONCEPCION",
  },
  {
    cod_dpto: "K",
    cod_dist: "K10",
    nom_dist: "SAN CRISTOBAL",
  },
  {
    cod_dpto: "B",
    cod_dist: "B15",
    nom_dist: "ITACUA",
  },
];

export const layers = [
  {
    title: "División departamental",
    layers: "snc:ly_dpto",
    visible: false,
  },
  {
    title: "División distrital",
    layers: "snc:ly_dist",
    visible: false,
  },
  {
    title: "Parcelas registradas",
    layers: "snc:ly_parc",
    visible: false,
  },
  {
    title: "Zona de seguridad fronteriza",
    layers: "snc:area_afectada",
    visible: false,
  },
];
